import { useEffect, useState } from "react";
import { specialOfferApi } from "@rshbintech.dboul/http";
import { SpecialOfferList, PlacementType } from "../types";
import { useMicroserviceAvailable } from "../../hooks";
import { MICROSERVICES_NAMES } from "../../common/constants";

export const useSpecialOfferData = (name: string, type: PlacementType) => {
  const isSpecialOffersMicroserviceAvailable = useMicroserviceAvailable(
    MICROSERVICES_NAMES.SPECIAL_OFFERS
  );

  const isSpecialOffersTemplatesMicroserviceAvailable =
    useMicroserviceAvailable(MICROSERVICES_NAMES.SPECIAL_OFFERS_TEMPLATES);

  const [data, setData] = useState<SpecialOfferList>([]);

  const [error, setError] = useState();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (isSpecialOffersMicroserviceAvailable) {
      setLoading(true);

      const request = isSpecialOffersTemplatesMicroserviceAvailable
        ? specialOfferApi.api.getSpecialOffersV2({ name, type })
        : specialOfferApi.api.getSpecialOffers({ name, type });

      request
        .then((specialOffersResponse) => {
          setData(
            specialOffersResponse.data.specialOffersForClientRespList || []
          );
        })
        .catch((error) => {
          setError(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [
    name,
    type,
    isSpecialOffersMicroserviceAvailable,
    isSpecialOffersTemplatesMicroserviceAvailable,
  ]);

  return {
    data,
    error,
    isLoading,
  };
};
